import { useMemo } from 'react';
import { Link } from 'react-router';
import { encodeUrl } from '../../utils/encodeUrl.ts';
import { trpc } from '../../utils/trpc/trpc.ts';


interface Props {
    partName: string;
}

export function PartNameResults({
    partName,
}: Props) {

    const { data: batches } = trpc.batches.get.useQuery({
        partName,
    });

    const options = useMemo(() => {
        if (!batches) return [];
        const equipments: { equipment: string; equipmentDisplayName: string; count: number }[] = [];
        for (const batch of batches) {
            const entry = equipments.find(it => it.equipment === batch.equipment);
            if (entry) {
                entry.count++;
            } else {
                equipments.push({
                    equipment: batch.equipment,
                    equipmentDisplayName: batch.equipmentDisplayName,
                    count: 1,
                });
            }
        }
        return equipments;
    }, [batches]);

    return (
        <table style={{ width: '800px' }}>
            <thead>
                <tr>
                    <th>Equipment</th>
                    <th>Batches</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {options.map(({ equipment, equipmentDisplayName, count }) => (
                    <tr key={equipment}>
                        <td className='textAlignLeft' style={{ paddingLeft: '60px' }}>
                            {equipmentDisplayName}
                        </td>
                        <td>{count}</td>
                        <td>
                            <Link
                                className='a__button'
                                to={encodeUrl('/spc-details', { equipment, partName })}
                            >
                                View
                            </Link>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
